import { useCallback, useMemo } from 'react'
import Condition from 'types/PrivateData/Condition'
import groupBy from 'lodash/groupBy'

export type MemberMedicalHistoryConditionsData = {
  member: string
  conditions: string
  relationship?: string
}

// TODO - improve visit type
export const useMemberMedicalHistoryConditions = (visit: any) => {
  const { medicalHistory, familyHistory, possibleConditions } = visit?.memberExtendedData?.privateData || {}
  const { currentConditions, currentOther } = medicalHistory || {}

  const getConditionName = useCallback(
    (conditionData: Condition) => {
      const { condition, name, conditionId } = conditionData

      if (condition && conditionId && possibleConditions?.length) {
        const possibleConditionGroup = possibleConditions?.find((pc) => pc.conditionId === conditionId)

        if (possibleConditionGroup?.types?.length) {
          const typeData = possibleConditionGroup.types.find((t) => t.key === condition)

          if (typeData?.name) return typeData.name
        }
      }

      return name
    },
    [possibleConditions],
  )

  const memberConditions = useMemo<MemberMedicalHistoryConditionsData>(
    () => ({
      member: 'Self',
      conditions: [...(currentConditions || []), ...(currentOther || [])]
        .map((item) => getConditionName(item) || item.value)
        .filter(Boolean)
        .join(', '),
    }),
    [currentConditions, currentOther, getConditionName],
  )

  const familyMembersConditions = useMemo<MemberMedicalHistoryConditionsData[]>(
    () =>
      Object.entries(groupBy(familyHistory?.currentConditions || [], 'relationship')).map(
        ([member, items]: [string, Condition[]]) => ({
          member,
          conditions: items.map(getConditionName).filter(Boolean).join(', '),
          relationship: member,
        }),
      ),
    [familyHistory?.currentConditions, getConditionName],
  )

  return { memberConditions, familyMembersConditions }
}
